package co.maytes.standupbot.dashboard.features.templateslist

import co.maytes.standupbot.dashboard.components.motion.ViewPhase
import co.maytes.standupbot.shared.dto.template.TemplateDto
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

object TemplatesListContract {
    sealed interface Status {
        data object Idle : Status
        data object Loading : Status
        data object Ready : Status
        data class Error(val message: String) : Status
    }

    data class State(
        val workspaceId: String = "",
        val status: Status = Status.Idle,
        val items: List<TemplateDto> = emptyList(),
        val deleteTargetId: String? = null,
    ) : MVIState {
        val phase: ViewPhase
            get() = when {
                items.isNotEmpty() -> ViewPhase.Ready
                status is Status.Error -> ViewPhase.Error
                status == Status.Ready -> ViewPhase.Empty
                else -> ViewPhase.Loading
            }
    }

    sealed interface Intent : MVIIntent {
        data class Load(val workspaceId: String) : Intent
        data object OpenNew : Intent
        data object OpenDuplicate : Intent
        data class OpenDetail(val id: String) : Intent
        data class RequestDelete(val id: String) : Intent
        data object CancelDelete : Intent
        data object ConfirmDelete : Intent
    }

    sealed interface Action : MVIAction {
        data class Navigate(val path: String) : Action
        data class Toast(val message: String, val error: Boolean = false) : Action
    }
}
